import type { PrStatus } from '../../shared/rules/statuses';
import { useI18n, type MessageKey } from '../i18n';

// A status is always a word; the tone only supports it (design system: StatusPill). Words and
// colours follow the status glossary (docs/07-DESIGN.md, D102).
const TONE: Partial<Record<PrStatus, 'success' | 'warning' | 'danger' | 'neutral'>> = {
  Draft: 'neutral',
  Cancelled: 'neutral',
  // Waiting on someone outside the normal flow: look now.
  Returned: 'warning',
  OnHold: 'warning',
  POSentPendingCFO: 'warning',
  Rejected: 'danger',
  // Finished well.
  Received: 'success',
  Paid: 'success',
  Closed: 'success',
};

/**
 * The words for a status. A returned request reads "Returned to you" for the person who raised
 * it and "Returned to requester" for everyone else (D102).
 */
export function statusKey(status: PrStatus, own = false): MessageKey {
  if (status === 'Returned' && own) return 'status.Returned.own';
  return `status.${status}` as MessageKey;
}

export function StatusPill({ status, own = false }: { status: PrStatus; own?: boolean }) {
  const { t } = useI18n();
  return <span class={`pill pill--${TONE[status] ?? 'info'}`}>{t(statusKey(status, own))}</span>;
}
